import IcSettings from './IcSettings'

export default IcSettings
